import { Avatar } from '@mui/material';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitterIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import TiktokIcon from 'src/components/TikTokIcon/TikTokIcon';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TelegramIcon from '@mui/icons-material/Telegram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { themeColors } from 'src/theme/schemes/PureLightTheme';
import { TSocialMedia } from 'src/models/general';
import GoogleIcon from '../GoogleIcon';
import ThreadsIcon from '../Threads/ThreadsIcon';
import RedditIcon from '../Reddit/RedditIcon';
import TokopediaIcon from '../TokopediaIcon';
import ShopeeIcon from '../ShopeeIcon';
import BlibliIcon from '../BlibliIcon';

import LazadaIcon from '../LazadaIcon';

interface IProps {
  socialMedia: TSocialMedia;
}

const GetSocialMediaIconWithBgColor = ({ socialMedia }: IProps) => {
  switch (socialMedia) {
    case 'twitter':
      return (
        <Avatar sx={{ bgcolor: '#000000', width: 23, height: 23 }}>
          <TwitterIcon fontSize="small" sx={{ width: 12, height: 12 }} />
        </Avatar>
      );
    case 'instagram':
      return (
        <Avatar sx={{ bgcolor: '#833AB4', width: 23, height: 23 }}>
          <InstagramIcon fontSize="small" sx={{ width: 12, height: 12 }} />
        </Avatar>
      );
    case 'youtube':
      return (
        <Avatar sx={{ bgcolor: '#FF0000', width: 23, height: 23 }}>
          <YouTubeIcon fontSize="small" sx={{ width: 12, height: 12 }} />
        </Avatar>
      );
    case 'facebook':
      return (
        <Avatar sx={{ bgcolor: '#4267B2', width: 23, height: 23 }}>
          <FacebookIcon fontSize="small" sx={{ width: 12, height: 12 }} />
        </Avatar>
      );
    case 'tiktok':
      return (
        <Avatar sx={{ bgcolor: themeColors.tiktok, width: 23, height: 23 }}>
          <TiktokIcon />
        </Avatar>
      );
    case 'linkedin':
      return (
        <Avatar sx={{ bgcolor: themeColors.linkedin, width: 23, height: 23 }}>
          <LinkedInIcon fontSize="small" sx={{ width: 14, height: 14 }} />
        </Avatar>
      );
    case 'googleReview':
      return (
        <Avatar sx={{ bgcolor: '#fff', width: 23, height: 23 }}>
          <GoogleIcon fontSize="small" sx={{ width: 12, height: 12 }} />
        </Avatar>
      );
    case 'telegram':
      return (
        <Avatar sx={{ bgcolor: themeColors.telegram, width: 23, height: 23 }}>
          <TelegramIcon fontSize="small" sx={{ width: 14, height: 14 }} />
        </Avatar>
      );
    case 'whatsapp':
      return (
        <Avatar sx={{ bgcolor: themeColors.whatsapp, width: 23, height: 23 }}>
          <WhatsAppIcon fontSize="small" sx={{ width: 14, height: 14 }} />
        </Avatar>
      );
    case 'threads':
      return (
        <Avatar sx={{ bgcolor: themeColors.threads, width: 23, height: 23 }}>
          <ThreadsIcon fontSize="small" sx={{ width: 14, height: 14 }} />
        </Avatar>
      );
    case 'reddit':
      return (
        <Avatar sx={{ bgcolor: themeColors.reddit, width: 23, height: 23 }}>
          <RedditIcon fontSize="small" sx={{ width: 14, height: 14 }} />
        </Avatar>
      );
    case 'tokopedia':
      return (
        <Avatar sx={{ bgcolor: '#42B549', width: 23, height: 23 }}>
          <TokopediaIcon fontSize="small" sx={{ width: 14, height: 14 }} />
        </Avatar>
      );
    case 'shopee':
      return (
        <Avatar sx={{ bgcolor: '#EE4D2D', width: 23, height: 23 }}>
          <ShopeeIcon fontSize="small" sx={{ width: 14, height: 14 }} />
        </Avatar>
      );
    case 'blibli':
      return (
        <Avatar sx={{ bgcolor: '#56B6E9', width: 23, height: 23 }}>
          <BlibliIcon fontSize="small" sx={{ width: 14, height: 14 }} />
        </Avatar>
      );
    case 'lazada':
      return (
        <Avatar sx={{ bgcolor: '#070286', width: 23, height: 23 }}>
          <LazadaIcon fontSize="small" sx={{ width: 14, height: 14 }} />
        </Avatar>
      );
    default:
      return (
        <Avatar sx={{ bgcolor: '#2098E7', width: 23, height: 23 }}>
          <TwitterIcon fontSize="small" sx={{ width: 12, height: 12 }} />
        </Avatar>
      );
  }
};

export default GetSocialMediaIconWithBgColor;
